import { render, staticRenderFns } from "./DetailClassAcceleration.vue?vue&type=template&id=754f6684"
import script from "./DetailClassAcceleration.vue?vue&type=script&lang=js"
export * from "./DetailClassAcceleration.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports